"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonschema_1 = require("jsonschema");
exports.ValidatorResult = jsonschema_1.ValidatorResult;
var schema_validator_1 = require("./schema_validator");
exports.SchemaValidator = schema_validator_1.SchemaValidator;
var schemas_1 = require("./schemas");
exports.schemas = schemas_1.schemas;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@0xproject/json-schemas/lib/src/index.js
// module id = 89
// module chunks = 0